import type { MxpModuleIdV2 } from './mxp365-v2.types';

// Maps every v2 module ID to its corresponding URL route segment (without
// leading slash). These are the exact "Route" values from the MXP v2 API docs
// (section 3.1). Parameterised modules use a bare base path; the parameter is
// appended by moduleToRoutePath() below.
const MODULE_TO_ROUTE: Readonly<Record<MxpModuleIdV2, string>> = {
  'mxp365-announcements': 'announcements',
  'mxp365-board-activities': 'activities/dailyevents/board-activities',
  'mxp365-chat': 'chat',
  'mxp365-daily-by-id': 'activities/dailyevents/by-de-id',
  'mxp365-deck-plan': 'deck-plan',
  'mxp365-favorites': 'favorites',
  'mxp365-fitness': 'activities/spa/fitness',
  'mxp365-hair-dresser': 'activities/spa/hair-dresser',
  'mxp365-makeup': 'activities/spa/permanent-makeup-parent',
  'mxp365-messages': 'messages',
  'mxp365-my-calendar': 'my-calendar',
  'mxp365-opening-hours': 'opening-hours',
  'mxp365-packages': 'packages',
  'mxp365-packages-by-id': 'packages-by-id',
  'mxp365-packages-mementos': 'packages-mementos',
  'mxp365-port-info': 'itinerary',
  'mxp365-questionnaires-by-id': 'questionnaires-by-id',
  'mxp365-restaurants': 'restaurants',
  'mxp365-restaurants-by-id': 'restaurants/by-ocs-id',
  'mxp365-safety-instructions': 'safety-info',
  'mxp365-shorex': 'activities/tours/shore-excursions',
  'mxp365-spa': 'activities/spa/spa',
  'mxp365-spa-balcony-cabin': 'spa-balcony',
  'mxp365-spa-by-id': 'activities/spa/by-im-id',
  'mxp365-tour-program-itinerary': 'activities/tours/by-tpi/shore-excursions',
  'mxp365-venues': 'venues',
  'mxp365-venues-by-id': 'venues-by-id',
  'mxp365-weather': 'weather',
};

/**
 * Returns the URL path segment for an MXP v2 module, with an optional
 * parameter appended (e.g. "activities/spa/by-im-id/42").
 * Falls back to the raw module ID so the iframe still loads something.
 */
export const moduleToRoutePath = (
  module: MxpModuleIdV2,
  parameter?: string | null,
): string => {
  const base = MODULE_TO_ROUTE[module] ?? module;
  return parameter ? `${base}/${parameter}` : base;
};
